module.exports = __webpack_public_path__ + "img/block11.463b5e7a.jpg";